import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

import { REVIEW_FRAGMENT } from '@base/api/fragments/review'

export const REVIEWS_QUERY = gql`
  ${REVIEW_FRAGMENT}
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${SERVER_ERROR}

  query getReviews(
    $clubId: String
    $userId: String
    $eventId: String
    $offset: Int!
  ) {
    getReviews(
      filter: { clubId: $clubId, userId: $userId, eventId: $eventId }
      sort: [{ sortField: CREATED_AT, sortOrder: DESC }]
      pagination: { limit: 10, offset: $offset }
    ) {
      ... on GetReviewsOutput {
        reviews {
          ...Review
        }
        count
      }
      ...ServerError
      ...UnauthenticatedError
      ...UnauthorizedError
    }
  }
`
